"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const hooks_1 = require("../../hooks");
const ui_1 = require("@completeanatomy/ui");
const drawLabelLines_1 = require("../../utils/drawLabelLines");
const labels_1 = require("../../utils/labels");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const LINE_WIDTH = 1;
const DOT_SIZE = 3;
// eslint-disable-next-line max-lines-per-function
function LabelsLines({ currentModelPosition, expandedLabelID, updatePosition, showLabelLines, offsetChanged, }) {
    const { labels, selectedLabelID, selectedLabelPartID } = (0, hooks_1.useLabels)();
    const theme = (0, styled_components_1.useTheme)();
    const windowSize = (0, ui_1.useScreenSize)();
    const canvasRef = (0, react_1.useRef)(null);
    const { isMobile } = (0, device_1.usePlatform)();
    const isLandscape = (0, ui_1.useOrientation)();
    // eslint-disable-next-line max-lines-per-function
    (0, react_1.useEffect)(() => {
        if (!canvasRef.current) {
            return;
        }
        const context = canvasRef.current.getContext('2d');
        if (!context) {
            return;
        }
        const canvasRect = canvasRef.current.getBoundingClientRect();
        context.clearRect(0, 0, canvasRect.width, canvasRect.height);
        labels === null || labels === void 0 ? void 0 : labels.forEach(label => {
            var _a, _b;
            if (!showLabelLines) {
                return;
            }
            if (expandedLabelID && expandedLabelID !== label.identifier) {
                return;
            }
            let labelElement = document.getElementById(label.identifier);
            if (label.modelPosition !== currentModelPosition ||
                label.orientation === bridge_schema_1.LabelOrientation.Undefined) {
                return;
            }
            if (label.type === bridge_schema_1.LabelType.Group &&
                (!selectedLabelPartID || label.identifier !== selectedLabelID)) {
                return;
            }
            let target = {
                x: label.target.x,
                y: label.target.y,
            };
            if (label.type === bridge_schema_1.LabelType.Group && ((_a = label.parts) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                return;
            }
            if (label.type === bridge_schema_1.LabelType.Group && label.parts) {
                const selectedPart = label.parts.find(part => part.object.identifier === selectedLabelPartID);
                if (selectedPart) {
                    labelElement = document.getElementById((_b = selectedPart.object) === null || _b === void 0 ? void 0 : _b.identifier);
                    target = {
                        x: selectedPart.target.x,
                        y: selectedPart.target.y,
                    };
                }
            }
            const dotX = target.x * windowSize.width;
            const dotY = target.y * windowSize.height;
            if (!labelElement) {
                return;
            }
            /**
             * If the target is outside the window, don't draw the line
             * This is to prevent the line from being drawn when model position is changed
             * but label's target wasn't updated yet
             */
            if (dotX > windowSize.width || dotY > windowSize.height) {
                return;
            }
            const { x, y, lineOffset } = (0, labels_1.calculatePointForLabel)(label, { x: dotX, y: dotY }, labelElement, selectedLabelPartID);
            if (x === undefined || y === undefined || lineOffset === undefined) {
                return;
            }
            const lineColor = label.identifier === selectedLabelID
                ? theme.labels.selectedLineColor
                : theme.labels.lineColor;
            (0, drawLabelLines_1.drawLabelLines)(context, x, y, dotX, dotY, lineOffset, lineColor, theme, LINE_WIDTH, DOT_SIZE);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        labels,
        selectedLabelPartID,
        currentModelPosition,
        selectedLabelID,
        expandedLabelID,
        updatePosition,
        showLabelLines,
        offsetChanged,
    ]);
    if (isMobile && !isLandscape) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(Canvas, { ref: canvasRef, width: windowSize.width, height: windowSize.height, "data-e2e": 'LabelsLines_Canvas' }));
}
exports.default = LabelsLines;
const Canvas = styled_components_1.default.canvas `
  width: 100%;
  height: 100%;

  position: absolute;

  user-select: none;
`;
